import React from 'react';
import './styles/StickmanRunner.css';

/**
 * Стикмен с портфелем — универсальная анимация загрузки.
 * size: 'sm' | 'md' | 'lg'
 */
const StickmanRunner = ({ size = 'md', className = '' }) => (
  <div
    className={`stickman-track stickman-track--${size} ${className}`.trim()}
    aria-hidden="true"
  >
    <div className="stickman-runner">
      <svg
        className="stickman-svg"
        viewBox="0 0 48 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g className="stickman-figure">
          <circle cx="20" cy="8" r="5" stroke="currentColor" strokeWidth="1.8" />
          <line x1="20" y1="13" x2="20" y2="32" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />

          <g className="stickman-arm stickman-arm--back">
            <line x1="20" y1="18" x2="12" y2="27" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </g>

          <g className="stickman-arm stickman-arm--front">
            <line x1="20" y1="18" x2="29" y2="26" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            <g className="stickman-briefcase">
              <rect x="27" y="24" width="10" height="8" rx="1.2" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.12" />
              <path d="M30 24v-2h4v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
          </g>

          <g className="stickman-leg stickman-leg--back">
            <line x1="20" y1="32" x2="13" y2="48" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </g>
          <g className="stickman-leg stickman-leg--front">
            <line x1="20" y1="32" x2="27" y2="48" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </g>
        </g>
      </svg>
      <div className="stickman-shadow" />
    </div>
    <div className="stickman-ground" />
  </div>
);

export default StickmanRunner;
